import { z } from 'zod';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
import { PlayerColor } from '../PlayerState.ts';
const mechanicRoadPlayerStateSchema = z.object({
    bankRoadAmount: z.number().int().nonnegative(),
    restrictedRoadPlacements: z.union([
        z.array(z.number().int().nonnegative()),
        z.null()
    ]).exactOptional()
}).strict();
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const mechanicRoadStateSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicRoadPlayerStateSchema);
export function validateMechanicRoadState(data) {
    return validateState(mechanicRoadStateSchema, data);
}
const mechanicRoadPlayerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicRoadPlayerStateSchema);
export const mechanicRoadStatePartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicRoadPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
